// 简单的前端导出：通过 HTML Table 生成 .xls（Excel/WPS 可直接打开）
export const exportTableToExcel = ({
	fileName,
	columns,
	rows
}) => {
	const name = fileName && String(fileName).trim() ? String(fileName).trim() : '导出.xls';
	const cols = Array.isArray(columns) ? columns : [];
	const data = Array.isArray(rows) ? rows : [];

	const escapeHtml = (value) => {
		if (value === null || value === undefined) {
			return '';
		}
		return String(value)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	};

	const getCellValue = (row, col) => {
		if (!col) {
			return '';
		}
		const prop = col.prop;
		const formatter = col.formatter;
		let raw = '';
		if (prop && row && Object.prototype.hasOwnProperty.call(row, prop)) {
			raw = row[prop];
		}
		const v = typeof formatter === 'function' ? formatter(raw, row) : raw;
		if (v === 0) {
			return 0;
		}
		return v || '';
	};

	const thead = `<tr>${cols.map(c => `<th>${escapeHtml(c.label || '')}</th>`).join('')}</tr>`;
	const tbody = data
		.map((row) => {
			const tds = cols.map((col) => `<td>${escapeHtml(getCellValue(row, col))}</td>`).join('');
			return `<tr>${tds}</tr>`;
		})
		.join('');

	const html = `
<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
<head><meta charset="utf-8"/></head>
<body><table>${thead}${tbody}</table></body>
</html>`.trim();

	const blob = new Blob(['\ufeff' + html], {
		type: 'application/vnd.ms-excel;charset=utf-8'
	});
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.download = (name.endsWith('.xls') || name.endsWith('.xlsx')) ? name : `${name}.xls`;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	window.URL.revokeObjectURL(url);
};
